<template>
  <a-breadcrumb separator="/">
    <template v-for='item of arr'>
      <a-breadcrumb-item v-if="item.url" :key='item.url'>
        <router-link :to='item.url'>{{item.title}}</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item v-else :key='item' >{{item}}</a-breadcrumb-item>
    </template>
  </a-breadcrumb>
</template>
<script>
export default {
  props: {
    arr: {
      type:Array,
      default(){
        return []
      }
    }
  },
  setup () {
    
  }
}
</script>